export default __webpack_public_path__ + "static/media/bitcoinist_logo.0864cd16.svg";